"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var type_guard_1 = require("../type-guard");
var Request = function (config) {
    // TODO: refactor so admin secret can be tree shaked out
    var isClientAdmin = (0, type_guard_1.isServerConfigurationWithClientSecret)(config);
    var isAdmin = ((0, type_guard_1.isServerConfigurationWithAdminSecret)(config));
    /**
     * execute a get request if exists in config
     * @param {string} url
     */
    var getMaybeAdmin = function (url) {
        // add admin key if exists
        if (isAdmin) {
            return getAdmin(url);
        }
        return get(url);
    };
    /**
     * execute a post request with admin secret if exists in config
     * @param url
     * @param data
     */
    var postMaybeAdmin = function (url, data) {
        // add admin key if exists
        if (isAdmin) {
            return postAdmin(url, data);
        }
        return post(url, data);
    };
    /**
     * execute a get request with admin secret
     * @param {string} url
     */
    var getAdmin = function (url) {
        if (!isAdmin)
            throw "You are not permitted to execute this request";
        return execute(url, "GET", {});
    };
    /**
     * execute a post request with admin secret
     * @param {string} url
     * @param {object} data
     */
    var postAdmin = function (url, data) {
        if (!isAdmin)
            throw "You are not permitted to execute this request";
        return execute(url, "POST", data);
    };
    /**
     * execute a get request
     * @param {string} url
     */
    var get = function (url) { return execute(url); };
    /**
     * execute post request
     * @param {string} url
     * @param {object} data
     */
    var post = function (url, data) { return execute(url, "POST", data); };
    /**
     * execute an ajax request
     */
    var execute = function (url, method, data) {
        if (method === void 0) { method = "GET"; }
        if (data === void 0) { data = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var headers, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        if ((0, type_guard_1.isServerConfigurationWithClientSecret)(config)) {
                            headers["OctaviusRocks-ClientSecret"] = config.clientSecret;
                        }
                        if ((0, type_guard_1.isServerConfigurationWithAdminSecret)(config)) {
                            headers["OctaviusRocks-AdminSecret"] = config.adminSecret;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, axios_1.default)(url, {
                                method: method,
                                data: data,
                                responseType: "json",
                                headers: __assign({ "Content-Type": "application/json" }, headers)
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status !== 200) {
                            throw "".concat(method, " Request to: ").concat(url, " | Status code: ").concat(response.status);
                        }
                        return [2 /*return*/, response.data];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * expose functions to public
     */
    return {
        getMaybeAdmin: getMaybeAdmin,
        postMaybeAdmin: postMaybeAdmin,
        getAdmin: getAdmin,
        postAdmin: postAdmin,
        get: get,
        post: post,
    };
};
exports.default = Request;
